import moment from "moment";
import Datepicker from "react-tailwindcss-datepicker";

const DateRangePicker = (props: any) => {
  const { label, setValue, name, getValues } = props

  const handleValueChange = (newValue: any) => {
    if (newValue?.startDate && newValue.endDate) {
      const startDate = new Date(`${newValue?.startDate}T00:00:00`);
      const formattedStartDate = startDate.toISOString();
      const endDate = new Date(`${newValue?.endDate}T23:59:00`);
      const formattedEndDate = endDate.toISOString();
      setValue(name, `${formattedStartDate},${formattedEndDate}`);
    } else {
      setValue(name, "")
    }
  };

  return (
    <div className="mt-2">
      <label htmlFor="" className="">{label}</label>
      <div className="mt-[12px]">
        <Datepicker
          inputClassName={"focus:outline-none bg-[#EEF5F4] w-full p-2"}
          popoverDirection="down" 
          value={{ startDate: getValues()?.[name]?.split(",")?.[0]??null, endDate: getValues()?.[name]?.split(",")?.[1]??null }}
          primaryColor={"pink"}
          onChange={handleValueChange}
          showShortcuts={true}
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
